/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'react-flexbox-grid';
import { useParams } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { RiArrowDropDownLine, RiCheckboxBlankLine, RiCheckboxFill } from 'react-icons/ri';

import DataTable from '@/components/DataTable';
import Badge from '@/components/Badge';
import SelectOne from '@/components/Forms/SelectOne';
import ContentLoader from 'react-content-loader';
import { translate } from '@/i18n/src/locales';
import TitlePage from '@/components/TitlePage';
import Switcher from '@/components/Forms/Switcher';
import InputMoney from '@/components/Forms/InputMoney';
import InputPercentage from '@/components/Forms/InputPercentage';
import Input from '@/components/Forms/Input';
import FormatDate from '@/components/Forms/FormatDate';

import Card from '@/components/Card';
import Check from '@/components/Forms/Check';
import { colors } from '@/template/styles';
import { fetchCouponById, addCoupon, editCoupon, releaseCouponToAll, fetchAllProductsCouponLoja, fetchCouponProductsLoja, updateCouponProduct } from '@/store/actions/coupon';

import { fetchCouponTypes } from '@/store/actions/couponTypes';
import { fetchAllPolesCouponLoja, fetchCouponPolesLoja, updateCouponPole } from '@/store/actions/couponPoles';
import { fetchCouponTypeApplication } from '@/store/actions/couponTypeApplication';
import { showAlert } from '@/store/actions/theme';
import { Container, Label } from './styles';
import * as S from './styles';

function CouponCreate() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const couponEdit = useSelector((state) => state.coupon.couponEdit);
  const couponIsLoading = useSelector((state) => state.coupon.couponIsLoading);
  const couponProductsIsLoading = useSelector((state) => state.coupon.couponProductsIsLoading);
  const couponpolesIsLoading = useSelector((state) => state.coupon.couponPolesIsLoading);

  const couponProducts = useSelector((state) => state.coupon.couponProducts);

  const couponPoles = useSelector((state) => state.couponPoles.couponsPole);

  const typeCoupon = useSelector((state) => state.couponTypes.couponTypes);
  const typeCouponApplication = useSelector((state) => state.couponTypeApplication.couponTypeApplication);
  const [isEdit, setIsEdit] = useState(false);

  const [openCollapseProduct, setOpenCollapseProduct] = useState(false);
  const [openCollapsePole, setOpenCollapsePole] = useState(false);

  const [couponCode, setCouponCode] = useState('');
  const [couponActive, setCouponActive] = useState(true);
  const [couponActiveFranqueadora, setCouponActiveFranqueadora] = useState(false);
  const [firstPurchase, setFirstPurchase] = useState(false);
  const [couponCodeStatus, setCouponCodeStatus] = useState({
    status: '',
    feedback: '',
  });

  // Novos estados para os campos adicionados
  const [qtdeAplicacao, setQtdeAplicacao] = useState('');
  const [qtdeAplicacaoStatus, setQtdeAplicacaoStatus] = useState({
    status: '',
    feedback: '',
  });

  const [idCupomRecorrencia, setIdCupomRecorrencia] = useState('1'); // 1 = Sem Recorrência (padrão)
  const [idCupomRecorrenciaOptions] = useState([
    { label: 'Sem Recorrência', value: '1' },
    { label: 'Diário', value: '2' },
    { label: 'Semanal', value: '3' },
    { label: 'Mensal', value: '4' },
    { label: 'Anual', value: '5' }
  ]);

  const [isRecorrenciaDisabled, setIsRecorrenciaDisabled] = useState(true);

  const [qtdeUso, setQtdeUso] = useState('0');
  const [qtdeUsoStatus, setQtdeUsoStatus] = useState({
    status: '',
    feedback: '',
  });


  // Estados simples para rastrear mudanças (objeto com chave = ID, valor = valor inicial)
  const [productInitialValues, setProductInitialValues] = useState({});
  const [poleInitialValues, setPoleInitialValues] = useState({});
  // Estados para armazenar valores atuais dos inputs
  const [productCurrentValues, setProductCurrentValues] = useState({});
  const [poleCurrentValues, setPoleCurrentValues] = useState({});
  // Estados para rastrear se há mudanças (objeto com chave = ID, valor = boolean)
  const [productHasChanges, setProductHasChanges] = useState({});
  const [poleHasChanges, setPoleHasChanges] = useState({});

  const [couponPrice, setCouponPrice] = useState('');
  const [couponPriceStatus, setCouponPriceStatus] = useState({
    status: '',
    feedback: '',
  });

  const [inputCouponTypes, setInputCouponTypes] = useState(null);
  const [inputCouponTypeApplication, setInputCouponTypeApplication] = useState(null);
  const [selectedCouponTypes, setSelectedCouponTypes] = useState(1);
  const [selectedCouponTypeApplication, setSelectedCouponTypeApplication] = useState(0);
  const [couponTypesStatus, setCouponTypesStatus] = useState({
    status: '',
    feedback: '',
  });
  const [couponTypeApplicationStatus, setCouponTypeApplicationStatus] = useState({
    status: '',
    feedback: '',
  });
  const [couponStartDate, setCouponStartDate] = useState('');
  const [couponStartDateStatus, setCouponStartDateStatus] = useState({
    status: '',
    feedback: '',
  });
  const [couponDueDate, setCouponDueDate] = useState('');
  const [couponDueDateStatus, setCouponDueDateStatus] = useState({
    status: '',
    feedback: '',
  });

  useEffect(() => {
    dispatch(fetchCouponTypes());
    dispatch(fetchCouponTypeApplication());

    if (id) {
      setIsEdit(true);
      dispatch(fetchCouponById(id));
    } else {
      // Resetar o estado para o modo de criação
      setIsEdit(false);
      setCouponCode('');
      setCouponActive(true);
      setCouponActiveFranqueadora(false);
      setFirstPurchase(false);
      setCouponCodeStatus({ status: '', feedback: '' });
      setQtdeAplicacao('0');
      setQtdeAplicacaoStatus({ status: '', feedback: '' });
      setIdCupomRecorrencia('1');
      setQtdeUso('0');
      setQtdeUsoStatus({ status: '', feedback: '' });
      setCouponPrice('');
      setCouponPriceStatus({ status: '', feedback: '' });
      setSelectedCouponTypes(1); // Resetar para tipo padrão (ex: Percentual)
      setSelectedCouponTypeApplication(0); // Resetar para tipo de aplicação padrão
      setCouponStartDate('');
      setCouponStartDateStatus({ status: '', feedback: '' });
      setCouponDueDate('');
      setCouponDueDateStatus({ status: '', feedback: '' });
      // TODO: Considerar resetar couponEdit, couponProducts, couponPoles se necessário
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (typeCoupon.length > 0) {
      setInputCouponTypes(
        typeCoupon.map((item) => ({
          label: item.Tipo,
          value: String(item.IdCupomTipo),
        }))
      );
    }
  }, [typeCoupon, dispatch]);

  useEffect(() => {
    if (typeCouponApplication.length > 0) {
      setInputCouponTypeApplication(
        typeCouponApplication.map((item) => ({
          label: item.Descricao,
          value: String(item.IdCupomTipoAplicacao),
        }))
      );
    }
  }, [typeCouponApplication]);

  useEffect(() => {
    if (isEdit && couponEdit) {
      setCouponCode(couponEdit.Codigo);
      setSelectedCouponTypes(couponEdit.IdCupomTipo);
      setCouponPrice(couponEdit.ValorDesconto.toFixed(2).replace('.', ','));
      setCouponStartDate(FormatDate(couponEdit.DataInicio));
      setCouponDueDate(FormatDate(couponEdit.DataFim));
      setSelectedCouponTypeApplication(parseInt(couponEdit.IdCupomTipoAplicacao, 10));
      setCouponActive(couponEdit.Ativo);
      setCouponActiveFranqueadora(couponEdit.AtivoFranqueadora || false);
      setFirstPurchase(couponEdit.PrimeiraCompra);

      // Carregando os novos campos
      setQtdeAplicacao(couponEdit.QtdeAplicacao?.toString() || '');
      setIdCupomRecorrencia(couponEdit.IdCupomRecorrencia?.toString() || '1');
      setQtdeUso(couponEdit.QtdeUso?.toString() || '0');

      dispatch(fetchAllProductsCouponLoja(couponEdit.IdCupom));
      dispatch(fetchAllPolesCouponLoja(couponEdit.IdCupom));
    }
  }, [isEdit, couponEdit]);


  // Validação em tempo real para o código do cupom
  useEffect(() => {
    if (couponCode.length > 15) {
      setCouponCodeStatus({ status: 'danger', feedback: 'O código não pode ter mais de 15 caracteres' });
    } else {
      setCouponCodeStatus({ status: '', feedback: '' }); // Limpa o erro se válido
    }
  }, [couponCode]);

  // Validação em tempo real para QtdeAplicacao
  useEffect(() => {
    const value = parseInt(qtdeAplicacao, 10);
    if (!isNaN(value) && value < 0) {
      setQtdeAplicacaoStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
    } else {
      setQtdeAplicacaoStatus({ status: '', feedback: '' });
    }
  }, [qtdeAplicacao]);

  // Validação em tempo real para QtdeUso
  useEffect(() => {
    const value = parseInt(qtdeUso, 10);
    if (!isNaN(value) && value < 0) {
      setQtdeUsoStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
    } else {
      setQtdeUsoStatus({ status: '', feedback: '' });
    }
  }, [qtdeUso]);

  // Validação em tempo real para CouponPrice
  useEffect(() => {
    // Garante que couponPrice é uma string antes de usar replace
    const priceString = String(couponPrice || '');
    const value = parseFloat(priceString.replace(',', '.'));
    if (!isNaN(value) && value < 0) {
      setCouponPriceStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
    } else {
      setCouponPriceStatus({ status: '', feedback: '' });
    }
  }, [couponPrice]);

  // Validação em tempo real para CouponStartDate
  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;

    let startDateValid = false; // Assume inválido inicialmente
    if (couponStartDate) {
      if (!dateFormatRegex.test(couponStartDate)) {
        setCouponStartDateStatus({ status: 'danger', feedback: 'Formato de data inválido (AAAA-MM-DD)' });
      } else {
        try {
          const [year, month, day] = couponStartDate.split('-').map(Number);
          // Verifica se o parsing resultou em números válidos e se a data é real
          const startDate = new Date(year, month - 1, day);
          if (isNaN(startDate.getTime())) {
            setCouponStartDateStatus({ status: 'danger', feedback: 'Data inválida' });
          } else if (startDate < today) {
            setCouponStartDateStatus({ status: 'danger', feedback: 'Data inicial não pode ser anterior à data atual' });
          } else {
            setCouponStartDateStatus({ status: '', feedback: '' });
            startDateValid = true; // Marca como válido apenas se passou em tudo
          }
        } catch (e) {
          setCouponStartDateStatus({ status: 'danger', feedback: 'Data inválida' });
        }
      }
    } else {
      setCouponStartDateStatus({ status: '', feedback: '' }); // Limpa se vazio
    }

    // Revalidar data final quando a inicial muda
    // Só revalida a data final se a inicial for considerada válida
    if (couponDueDate && startDateValid) {
      if (!dateFormatRegex.test(couponDueDate)) {
        setCouponDueDateStatus({ status: 'danger', feedback: 'Formato de data inválido (AAAA-MM-DD)' });
      } else {
        try {
          const [startYear, startMonth, startDay] = couponStartDate.split('-').map(Number);
          const startDate = new Date(startYear, startMonth - 1, startDay);
          const [dueYear, dueMonth, dueDay] = couponDueDate.split('-').map(Number);
          const dueDate = new Date(dueYear, dueMonth - 1, dueDay);

          if (isNaN(dueDate.getTime())) {
            setCouponDueDateStatus({ status: 'danger', feedback: 'Data inválida' });
          } else if (dueDate < startDate) {
            setCouponDueDateStatus({ status: 'danger', feedback: 'Data final não pode ser anterior à data inicial' });
          } else {
            setCouponDueDateStatus({ status: '', feedback: '' });
          }
        } catch (e) {
          setCouponDueDateStatus({ status: 'danger', feedback: 'Data inválida' });
        }
      }
    } else if (couponDueDate && !startDateValid) {
      // Se a data inicial é inválida, não podemos validar a final contra ela, mas podemos checar formato da final
      if (!dateFormatRegex.test(couponDueDate)) {
        setCouponDueDateStatus({ status: 'danger', feedback: 'Formato de data inválido (AAAA-MM-DD)' });
      }
    }

  }, [couponStartDate, couponDueDate]);

  // Validação em tempo real para CouponDueDate
  useEffect(() => {
    const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
    let startDateValid = false;
    let startDate; // Para armazenar a data inicial parseada se válida

    // Primeiro valida formato e data inicial
    if (couponStartDate && dateFormatRegex.test(couponStartDate)) {
      try {
        const [startYear, startMonth, startDay] = couponStartDate.split('-').map(Number);
        startDate = new Date(startYear, startMonth - 1, startDay);
        if (!isNaN(startDate.getTime())) {
          startDateValid = true;
        }
      } catch (e) { /* Ignora erro de parsing aqui, foca na data final */ }
    }

    // Agora valida formato e data final
    if (couponDueDate) {
      if (!dateFormatRegex.test(couponDueDate)) {
        setCouponDueDateStatus({ status: 'danger', feedback: 'Formato de data inválido (AAAA-MM-DD)' });
      } else {
        try {
          const [dueYear, dueMonth, dueDay] = couponDueDate.split('-').map(Number);
          const dueDate = new Date(dueYear, dueMonth - 1, dueDay);

          if (isNaN(dueDate.getTime())) {
            setCouponDueDateStatus({ status: 'danger', feedback: 'Data inválida' });
          } else if (startDateValid && dueDate < startDate) {
            // Só compara se a data inicial for válida
            setCouponDueDateStatus({ status: 'danger', feedback: 'Data final não pode ser anterior à data inicial' });
          } else {
            setCouponDueDateStatus({ status: '', feedback: '' }); // Formato ok e data >= inicial (ou inicial inválida)
          }
        } catch (e) {
          setCouponDueDateStatus({ status: 'danger', feedback: 'Data inválida' });
        }
      }
    } else {
      setCouponDueDateStatus({ status: '', feedback: '' }); // Limpa se vazio
    }
  }, [couponStartDate, couponDueDate]);

  useEffect(() => {
    if (!qtdeUso || qtdeUso === '0') {
      setIdCupomRecorrencia('1');
      setIsRecorrenciaDisabled(true);
    } else {
      setIsRecorrenciaDisabled(false);
    }
  }, [qtdeUso]);

  // Inicializar valores iniciais dos produtos
  useEffect(() => {
    if (couponProducts && Array.isArray(couponProducts)) {
      const initial = {};
      const current = {};
      couponProducts.forEach((product) => {
        const value = String(product.QtdeAplicacao ?? '0');
        initial[product.IdProduto] = value;
        current[product.IdProduto] = value;
      });
      setProductInitialValues(initial);
      setProductCurrentValues(current);
      // Resetar flags de mudança quando dados são recarregados
      setProductHasChanges({});
    }
  }, [couponProducts]);

  // Inicializar valores iniciais dos polos
  useEffect(() => {
    if (couponPoles && Array.isArray(couponPoles)) {
      const initial = {};
      const current = {};
      couponPoles.forEach((pole) => {
        const values = {
          qtdeUso: String(pole.QtdeUso ?? '0'),
          idCupomRecorrencia: String(pole.IdCupomRecorrencia ?? '1')
        };
        initial[pole.IdPolo] = values;
        current[pole.IdPolo] = values;
      });
      setPoleInitialValues(initial);
      setPoleCurrentValues(current);
      // Resetar flags de mudança quando dados são recarregados
      setPoleHasChanges({});
    }
  }, [couponPoles]);

  const changeCouponTypes = useCallback((item) => {
    setSelectedCouponTypes(parseInt(item.value, 10));
    // Resetar o valor do desconto ao mudar o tipo
    setCouponPrice('');
  }, []);

  const changeCouponTypeApplication = useCallback((item) => {
    setSelectedCouponTypeApplication(parseInt(item.value, 10));
  }, []);

  // Novo callback para o campo de recorrência
  const changeRecorrencia = useCallback((item) => {
    setIdCupomRecorrencia(item ? item.value : '1');
  }, []);

  const handleAddCoupon = useCallback(() => {
    let formErro = false;

    if (!couponCode) {
      setCouponCodeStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    }

    // Validação de tamanho máximo do código
    if (couponCode.length > 15) {
      setCouponCodeStatus({ status: 'danger', feedback: 'O código não pode ter mais de 15 caracteres' });
      formErro = true;
    }

    if (!couponPrice) {
      setCouponPriceStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    }

    if (!couponStartDate) {
      setCouponStartDateStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    }

    if (!couponDueDate) {
      setCouponDueDateStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    }

    // Validação para os novos campos
    if (qtdeAplicacao && isNaN(parseInt(qtdeAplicacao, 10))) {
      setQtdeAplicacaoStatus({ status: 'danger', feedback: 'Valor inválido' });
      formErro = true;
    }

    if (qtdeUso && isNaN(parseInt(qtdeUso, 10))) {
      setQtdeUsoStatus({ status: 'danger', feedback: 'Valor inválido' });
      formErro = true;
    }

    // Validação de números negativos
    if (parseInt(qtdeAplicacao, 10) < 0) {
      setQtdeAplicacaoStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
      formErro = true;
    }

    if (parseInt(qtdeUso, 10) < 0) {
      setQtdeUsoStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
      formErro = true;
    }

    if (parseFloat(couponPrice.replace(',', '.')) < 0) {
      setCouponPriceStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
      formErro = true;
    }

    // Validação de datas
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const [startYear, startMonth, startDay] = couponStartDate.split('-').map(Number);
    const startDate = new Date(startYear, startMonth - 1, startDay);
    startDate.setHours(0, 0, 0, 0);

    const [dueYear, dueMonth, dueDay] = couponDueDate.split('-').map(Number);
    const dueDate = new Date(dueYear, dueMonth - 1, dueDay);
    dueDate.setHours(0, 0, 0, 0);

    if (startDate < today) {
      setCouponStartDateStatus({ status: 'danger', feedback: 'Data inicial não pode ser anterior à data atual' });
      formErro = true;
    }

    if (dueDate < startDate) {
      setCouponDueDateStatus({ status: 'danger', feedback: 'Data final não pode ser anterior à data inicial' });
      formErro = true;
    }

    // Verificar se os tipos estão selecionados
    if (!selectedCouponTypes) {
      setCouponTypesStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    } else {
      setCouponTypesStatus({ status: '', feedback: '' });
    }

    if (!selectedCouponTypeApplication) {
      setCouponTypeApplicationStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    } else {
      setCouponTypeApplicationStatus({ status: '', feedback: '' });
    }

    if (formErro) {
      dispatch(
        showAlert({
          type: 'warning',
          message: 'Por favor, corrija os erros no formulário antes de continuar.',
          time: 4000,
        })
      );

      setTimeout(() => {
        const errorInputs = document.querySelectorAll('input[type="text"], input[type="number"], input[type="date"], select');
        for (let input of errorInputs) {
          const parent = input.closest('.form-group, [class*="input"], [class*="form"]');
          if (parent && (parent.textContent.includes('danger') || parent.querySelector('[class*="danger"]'))) {
            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            input.focus();
            break;
          }
        }
      }, 100);
      return;
    }

    if (!formErro) {
      // Garantir que campos numéricos são números e não strings
      const qtdeAplicacaoValue = qtdeAplicacao ? parseInt(qtdeAplicacao, 10) : 0;
      const idCupomRecorrenciaValue = idCupomRecorrencia ? parseInt(idCupomRecorrencia, 10) : 1;
      const qtdeUsoValue = qtdeUso ? parseInt(qtdeUso, 10) : 0;

      dispatch(
        addCoupon({
          Codigo: couponCode,
          IdCupomTipo: selectedCouponTypes,
          ValorDesconto: String(couponPrice || '').replace(',', '.'),
          Ativo: couponActive,
          DataInicio: couponStartDate,
          DataFim: couponDueDate,
          IdCupomTipoAplicacao: selectedCouponTypeApplication,
          PrimeiraCompra: firstPurchase,
          QtdeAplicacao: qtdeAplicacaoValue,
          IdCupomRecorrencia: idCupomRecorrenciaValue,
          QtdeUso: qtdeUsoValue,
          AtivoFranqueadora: couponActiveFranqueadora
        })
      );
    }
  }, [dispatch, couponCode, selectedCouponTypes, couponPrice, couponActive, couponActiveFranqueadora, couponStartDate, couponDueDate, selectedCouponTypeApplication, firstPurchase, qtdeAplicacao, idCupomRecorrencia, qtdeUso]);

  const handleEditCoupon = useCallback(() => {
    let formErro = false;

    if (!couponCode) {
      setCouponCodeStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    }

    // Validação de tamanho máximo do código
    if (couponCode.length > 15) {
      setCouponCodeStatus({ status: 'danger', feedback: 'O código não pode ter mais de 15 caracteres' });
      formErro = true;
    }

    if (!couponPrice) {
      setCouponPriceStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    }

    // Validação para os novos campos
    if (qtdeAplicacao && isNaN(parseInt(qtdeAplicacao, 10))) {
      setQtdeAplicacaoStatus({ status: 'danger', feedback: 'Valor inválido' });
      formErro = true;
    }

    if (qtdeUso && isNaN(parseInt(qtdeUso, 10))) {
      setQtdeUsoStatus({ status: 'danger', feedback: 'Valor inválido' });
      formErro = true;
    }

    // Validação de números negativos
    if (parseInt(qtdeAplicacao, 10) < 0) {
      setQtdeAplicacaoStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
      formErro = true;
    }

    if (parseInt(qtdeUso, 10) < 0) {
      setQtdeUsoStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
      formErro = true;
    }

    if (parseFloat(couponPrice.replace(',', '.')) < 0) {
      setCouponPriceStatus({ status: 'danger', feedback: 'Não é permitido valor negativo' });
      formErro = true;
    }

    // Validação de datas
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const [startYear, startMonth, startDay] = couponStartDate.split('-').map(Number);
    const startDate = new Date(startYear, startMonth - 1, startDay);
    startDate.setHours(0, 0, 0, 0);

    const [dueYear, dueMonth, dueDay] = couponDueDate.split('-').map(Number);
    const dueDate = new Date(dueYear, dueMonth - 1, dueDay);
    dueDate.setHours(0, 0, 0, 0);

    if (startDate < today) {
      setCouponStartDateStatus({ status: 'danger', feedback: 'Data inicial não pode ser anterior à data atual' });
      formErro = true;
    }

    if (dueDate < startDate) {
      setCouponDueDateStatus({ status: 'danger', feedback: 'Data final não pode ser anterior à data inicial' });
      formErro = true;
    }

    // Verificar se os tipos estão selecionados
    if (!selectedCouponTypes) {
      setCouponTypesStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    } else {
      setCouponTypesStatus({ status: '', feedback: '' });
    }

    if (!selectedCouponTypeApplication) {
      setCouponTypeApplicationStatus({ status: 'danger', feedback: 'Campo obrigatório' });
      formErro = true;
    } else {
      setCouponTypeApplicationStatus({ status: '', feedback: '' });
    }

    if (formErro) {
      dispatch(
        showAlert({
          type: 'warning',
          message: 'Por favor, corrija os erros no formulário antes de continuar.',
          time: 4000,
        })
      );

      setTimeout(() => {
        const errorInputs = document.querySelectorAll('input[type="text"], input[type="number"], input[type="date"], select');
        for (let input of errorInputs) {
          const parent = input.closest('.form-group, [class*="input"], [class*="form"]');
          if (parent && (parent.textContent.includes('danger') || parent.querySelector('[class*="danger"]'))) {
            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            input.focus();
            break;
          }
        }
      }, 100);
      return;
    }

    if (!formErro) {
      // Garantir que campos numéricos são números e não strings
      const qtdeAplicacaoValue = qtdeAplicacao ? parseInt(qtdeAplicacao, 10) : 0;
      const idCupomRecorrenciaValue = idCupomRecorrencia ? parseInt(idCupomRecorrencia, 10) : 1;
      const qtdeUsoValue = qtdeUso ? parseInt(qtdeUso, 10) : 0;
      const payload = {
        idCupom: id,
        Codigo: couponCode,
        IdCupomTipo: selectedCouponTypes,
        ValorDesconto: String(couponPrice || '').replace(',', '.'),
        Ativo: couponActive,
        DataInicio: couponStartDate,
        DataFim: couponDueDate,
        IdCupomTipoAplicacao: selectedCouponTypeApplication,
        PrimeiraCompra: firstPurchase,
        QtdeAplicacao: qtdeAplicacaoValue,
        IdCupomRecorrencia: idCupomRecorrenciaValue,
        QtdeUso: qtdeUsoValue,
        AtivoFranqueadora: couponActiveFranqueadora
      };

      dispatch(editCoupon(payload));
    }
  }, [id, dispatch, couponCode, selectedCouponTypes, couponPrice, couponActive, couponActiveFranqueadora, couponStartDate, couponDueDate, selectedCouponTypeApplication, firstPurchase, qtdeAplicacao, idCupomRecorrencia, qtdeUso]);

  const toogleCouponProduct = useCallback(
    (idProduct, enable, rowQtdeAplicacao) => {
      const qtdeAplicacaoValue = rowQtdeAplicacao !== undefined && rowQtdeAplicacao !== null
        ? parseInt(rowQtdeAplicacao, 10)
        : (qtdeAplicacao ? parseInt(qtdeAplicacao, 10) : 0);

      if (qtdeAplicacaoValue < 0) {
        setQtdeAplicacaoStatus({
          status: 'danger',
          feedback: translate('validateQtdeAplicacao')
        });
        return;
      }

      if (enable) {
        dispatch(
          fetchCouponProductsLoja({
            IdProduto: idProduct,
            IdCupom: id,
            Ativo: true,
            QtdeAplicacao: qtdeAplicacaoValue
          })
        );
      } else {
        dispatch(
          updateCouponProduct({
            IdProduto: idProduct,
            IdCupom: id,
            Ativo: false,
            QtdeAplicacao: qtdeAplicacaoValue
          })
        );
      }
    },
    [dispatch, id, qtdeAplicacao]
  );

  const toogleCouponPole = useCallback(
    (idPole, idCoupon, enable, rowQtdeUso, rowIdCupomRecorrencia) => {
      const qtdeUsoValue = rowQtdeUso !== undefined && rowQtdeUso !== null
        ? parseInt(rowQtdeUso, 10)
        : (qtdeUso ? parseInt(qtdeUso, 10) : 0);

      let idCupomRecorrenciaValue;
      if (rowIdCupomRecorrencia !== undefined && rowIdCupomRecorrencia !== null) {
        const parsedValue = parseInt(rowIdCupomRecorrencia, 10);
        idCupomRecorrenciaValue = (parsedValue >= 1 && parsedValue <= 5) ? parsedValue : 1;
      } else {
        const defaultRecorrencia = idCupomRecorrencia ? parseInt(idCupomRecorrencia, 10) : 1;
        idCupomRecorrenciaValue = (defaultRecorrencia >= 1 && defaultRecorrencia <= 5) ? defaultRecorrencia : 1;
      }

      if (qtdeUsoValue < 0) {
        setQtdeUsoStatus({
          status: 'danger',
          feedback: translate('validateQtdeUso')
        });
        return;
      }

      if (enable) {
        dispatch(
          fetchCouponPolesLoja({
            IdPolo: idPole,
            IdCupom: idCoupon,
            Ativo: true,
            IdCupomRecorrencia: idCupomRecorrenciaValue,
            QtdeUso: qtdeUsoValue
          })
        );
      } else {
        dispatch(
          updateCouponPole({
            IdPolo: idPole,
            IdCupom: idCoupon,
            Ativo: false,
            IdCupomRecorrencia: idCupomRecorrenciaValue,
            QtdeUso: qtdeUsoValue
          })
        );
      }
    },
    [dispatch, idCupomRecorrencia, qtdeUso]
  );

  return (
    <>
      <Helmet>
        <title>{isEdit ? translate('addCoupon') : translate('createCoupon')}</title>
      </Helmet>
      <TitlePage title={isEdit ? translate('addCoupon') : translate('createCoupon')} />
      <Card title={isEdit ? translate('addCoupon') : translate('createCoupon')}>
        {couponIsLoading ? (
          <ContentLoader width="100%" speed={1} height="380px" backgroundColor="#c6c6c6" foregroundColor="#F0F0F5">
            <rect x="0" y="0" rx="5px" ry="5px" width="100%" height="40px" />
            <rect x="0" y="60" rx="5px" ry="5px" width="100%" height="40px" />
            <rect x="0" y="120" rx="5px" ry="5px" width="100%" height="40px" />
            <rect x="0" y="180" rx="5px" ry="5px" width="100%" height="40px" />
            <rect x="0" y="240" rx="5px" ry="5px" width="100%" height="40px" />
            <rect x="0" y="300" rx="5px" ry="5px" width="100%" height="40px" />
          </ContentLoader>
        ) : (
          <>
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs={12} md={12}>
                    <Input
                      value={couponCode}
                      type="text"
                      label={translate('code')}
                      status={couponCodeStatus}
                      change={(value) => setCouponCode(value)}
                      maxLength={15}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={4}>
                    {inputCouponTypes && (
                      <SelectOne
                        label={translate('typeCoupom')}
                        options={inputCouponTypes}
                        value={inputCouponTypes.find((item) => item.value === String(selectedCouponTypes))}
                        change={(item) => {
                          changeCouponTypes(item);
                          setCouponTypesStatus({ status: '', feedback: '' });
                        }}
                        isSearchable={false}
                        placeholder={translate('selectAType')}
                        status={couponTypesStatus}
                      />
                    )}
                  </Col>
                  <Col xs={12} md={4}>
                    {inputCouponTypeApplication && (
                      <SelectOne
                        label={translate('couponTypeApplication')}
                        options={inputCouponTypeApplication}
                        value={inputCouponTypeApplication.find((item) => item.value === String(selectedCouponTypeApplication))}
                        change={(item) => {
                          changeCouponTypeApplication(item);
                          setCouponTypeApplicationStatus({ status: '', feedback: '' });
                        }}
                        placeholder={translate('selectCouponTypeApplication')}
                        status={couponTypeApplicationStatus}
                      />
                    )}
                  </Col>
                  <Col xs={4} md={2}>
                    <Switcher set={setFirstPurchase} value={firstPurchase} label={translate('firstPurchase')} />
                  </Col>
                  <Col xs={4} md={2}>
                    <Switcher set={setCouponActive} value={couponActive} label={translate('activeCoupon')} />
                  </Col>
                  {isEdit && (
                    <Col xs={4} md={2}>
                      <Switcher set={setCouponActiveFranqueadora} value={couponActiveFranqueadora} label="Liberado para todos" />
                    </Col>
                  )}
                </Row>
                <Row className="mt">
                  <Col xs={12} md={4}>
                    {(!selectedCouponTypes || (selectedCouponTypes !== 1 && selectedCouponTypes !== 2)) && (
                      <Container>
                        <Label>{translate('discount')}</Label>
                        <input disabled />
                      </Container>
                    )}
                    {selectedCouponTypes === 2 && (
                      <InputMoney
                        value={couponPrice}
                        label={translate('discount')}
                        status={couponPriceStatus}
                        change={(value) => setCouponPrice(value)}
                      />
                    )}
                    {selectedCouponTypes === 1 && (
                      <InputPercentage
                        value={couponPrice}
                        label={translate('discount')}
                        status={couponPriceStatus}
                        change={(value) => setCouponPrice(value)}
                      />
                    )}
                  </Col>
                  <Col xs={12} md={4}>
                    <Input
                      value={couponStartDate}
                      type="date"
                      label={translate('startDate')}
                      status={couponStartDateStatus}
                      change={(value) => setCouponStartDate(value)}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <Input
                      value={couponDueDate}
                      type="date"
                      label={translate('dueDate')}
                      status={couponDueDateStatus}
                      change={(value) => setCouponDueDate(value)}
                    />
                  </Col>
                </Row>
                <Row className="mt">
                  <Col xs={12} md={4}>
                    <Input
                      type="number"
                      label="Limite Total de Uso"
                      tooltip="Quantas vezes este cupom pode ser usado no total (0 = ilimitado)"
                      value={qtdeUso}
                      status={qtdeUsoStatus}
                      change={(value) => setQtdeUso(value)}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <SelectOne
                      options={idCupomRecorrenciaOptions}
                      label="Tipo de Recorrência"
                      tooltip="Define a frequência com que o cupom pode ser usado"
                      value={idCupomRecorrenciaOptions.find((item) => item.value === idCupomRecorrencia)}
                      change={(item) => changeRecorrencia(item)}
                      placeholder="Selecione"
                      isDisabled={isRecorrenciaDisabled}
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <Input
                      type="number"
                      label="Quantidade de Aplicações por Produto"
                      tooltip="Quantas vezes este cupom pode ser aplicado por produto (0 = ilimitado)"
                      value={qtdeAplicacao}
                      status={qtdeAplicacaoStatus}
                      change={(value) => setQtdeAplicacao(value)}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                {isEdit ? (
                  <button type="button" className="btn btn-primary mt" onClick={() => handleEditCoupon()}>
                    Salvar Mudanças
                  </button>
                ) : (
                  <button type="button" className="btn btn-primary mt" onClick={handleAddCoupon}>
                    Salvar
                  </button>
                )}
              </Col>
            </Row>
          </>
        )}
      </Card>

      {couponIsLoading || couponProductsIsLoading ? (
        <ContentLoader width="100%" speed={1} height="380px" backgroundColor="#c6c6c6" foregroundColor="#F0F0F5">
          <rect x="0" y="0" rx="5px" ry="5px" width="100%" height="80px" />
          <rect x="0" y="100" rx="5px" ry="5px" width="100%" height="80px" />
        </ContentLoader>
      ) : (
        isEdit && (selectedCouponTypeApplication != 1 && selectedCouponTypeApplication != 4 && selectedCouponTypeApplication != 0) && (
          <>
            <S.CollapseItem>
              <div className="header" onClick={() => setOpenCollapseProduct(!openCollapseProduct)}>
                <div className="title">
                  <div>Vincular Produto</div>
                </div>
                <div className="item-action">
                  <S.ArrowCollapse open={openCollapseProduct}>
                    <RiArrowDropDownLine size={30} />
                  </S.ArrowCollapse>
                </div>
              </div>
              <S.CollapseBody isOpen={openCollapseProduct} transition="height 0.4s cubic-bezier(.4, 0, .2, 1">
                {couponProducts && (
                  <DataTable
                    data={couponProducts}
                    searchPlaceHolder="Buscar Produtos"
                    columns={[
                      {
                        compact: true,
                        center: true,
                        width: '60px',
                        cell: (row) => <img src={row.Imagem} alt={row.Nome} />,
                      },
                      {
                        name: 'Nome',
                        selector: 'Nome',
                        sortable: true,
                      },
                      {
                        name: 'Quantidade de Aplicações por Produto',
                        selector: 'Quantidade de Aplicações por Produto',
                        width: '300px',
                        center: true,
                        cell: (row) => {
                          const rowValue = row.QtdeAplicacao !== undefined && row.QtdeAplicacao !== null ? String(row.QtdeAplicacao) : '0';
                          const isDisabled = !row.Vinculado;
                          const idProduto = row.IdProduto;
                          const initialValue = productInitialValues[idProduto] || rowValue;
                          const currentValue = productCurrentValues[idProduto] !== undefined ? productCurrentValues[idProduto] : rowValue;
                          const hasChanges = productHasChanges[idProduto] || false;
                          const containerId = `produto-container-${idProduto}`;

                          return (
                            <div id={containerId} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                              <input
                                type="number"
                                className="input-sm"
                                value={currentValue}
                                min="0"
                                disabled={isDisabled}
                                onKeyDown={(e) => {
                                  if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = e.target.value || '0';
                                  let finalValue = value;
                                  if (value && parseInt(value, 10) < 0) {
                                    finalValue = '0';
                                  }
                                  // Atualizar valor atual
                                  setProductCurrentValues(prev => ({
                                    ...prev,
                                    [idProduto]: finalValue
                                  }));
                                  // Verificar se há mudanças
                                  setProductHasChanges(prev => ({
                                    ...prev,
                                    [idProduto]: initialValue !== finalValue
                                  }));
                                }}
                                style={{
                                  width: '80px',
                                  textAlign: 'center',
                                  opacity: isDisabled ? 0.6 : 1,
                                  cursor: isDisabled ? 'not-allowed' : 'text'
                                }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm"
                                style={{
                                  width: '40px',
                                  minWidth: '40px',
                                  backgroundColor: hasChanges && !isDisabled ? '#007bff' : 'transparent',
                                  color: hasChanges && !isDisabled ? '#fff' : 'transparent',
                                  border: 'none',
                                  borderRadius: '5px',
                                  cursor: hasChanges && !isDisabled ? 'pointer' : 'default',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontWeight: 'bold',
                                  fontSize: '1.4rem',
                                  visibility: hasChanges && !isDisabled ? 'visible' : 'hidden',
                                  pointerEvents: hasChanges && !isDisabled ? 'auto' : 'none'
                                }}
                                disabled={!hasChanges || isDisabled}
                                onClick={(e) => {
                                  if (!hasChanges || isDisabled) return;
                                  const currentVal = productCurrentValues[idProduto] || rowValue;
                                  const qtdeAplicacaoValue = parseInt(currentVal, 10) || 0;
                                  if (qtdeAplicacaoValue >= 0) {
                                    dispatch(
                                      updateCouponProduct({
                                        IdProduto: idProduto,
                                        IdCupom: id,
                                        Ativo: row.Vinculado,
                                        QtdeAplicacao: qtdeAplicacaoValue
                                      })
                                    );
                                    // Atualizar valor inicial e remover flag de mudança
                                    const newValue = String(qtdeAplicacaoValue);
                                    setProductInitialValues(prev => ({
                                      ...prev,
                                      [idProduto]: newValue
                                    }));
                                    setProductCurrentValues(prev => ({
                                      ...prev,
                                      [idProduto]: newValue
                                    }));
                                    setProductHasChanges(prev => ({
                                      ...prev,
                                      [idProduto]: false
                                    }));
                                  }
                                }}
                                title="Salvar alteração"
                              >
                                ✓
                              </button>
                            </div>
                          );
                        },
                      },
                      {
                        name: 'Ativo',
                        selector: 'Ativo',
                        width: '60px',
                        cell: (row) => (
                          <div
                            className="check-trail-module"
                            onClick={() => toogleCouponProduct(row.IdProduto, !row.Vinculado, row.QtdeAplicacao)}
                          >
                            {row.Vinculado ? (
                              <RiCheckboxFill size={25} color={colors.success} />
                            ) : (
                              <RiCheckboxBlankLine size={25} />
                            )}
                          </div>
                        ),
                      },
                    ]}
                    columnFilter="Nome"
                  />
                )}
              </S.CollapseBody>
            </S.CollapseItem>
          </>
        )
      )}

      {(couponIsLoading || couponpolesIsLoading) ? (
        <ContentLoader width="100%" speed={1} height="380px" backgroundColor="#c6c6c6" foregroundColor="#F0F0F5">
          <rect x="0" y="0" rx="5px" ry="5px" width="100%" height="80px" />
          <rect x="0" y="100" rx="5px" ry="5px" width="100%" height="80px" />
        </ContentLoader>
      ) : (
        isEdit && (
          <>
            <S.CollapseItem>
              <div className="header" onClick={() => setOpenCollapsePole(!openCollapsePole)}>
                <div className="title">
                  <div>Vincular Polo</div>
                </div>
                <div className="item-action">
                  <S.ArrowCollapse open={openCollapsePole}>
                    <RiArrowDropDownLine size={30} />
                  </S.ArrowCollapse>
                </div>
              </div>
              <S.CollapseBody isOpen={openCollapsePole} transition="height 0.4s cubic-bezier(.4, 0, .2, 1">
                {couponPoles && (
                  <DataTable
                    data={couponPoles}
                    searchPlaceHolder={translate('searchPoleName')}
                    columns={[
                      { name: translate('poleName'), selector: 'NomePolo', sortable: true },
                      {
                        name: translate('externalCode'),
                        selector: 'CodigoExternoPolo',
                        sortable: true,
                      },
                      {
                        name: 'Limite de Uso / Tipo de Recorrência',
                        selector: 'QuantidadeAplicacaoTipoRecorrencia',
                        width: '350px',
                        center: true,
                        cell: (row) => {
                          const rowValue = row.QtdeUso !== undefined && row.QtdeUso !== null ? String(row.QtdeUso) : '0';
                          const rowRecorrencia = row.IdCupomRecorrencia !== undefined && row.IdCupomRecorrencia !== null ? String(row.IdCupomRecorrencia) : '1';
                          const isDisabled = row.Ativo;
                          const idPolo = row.IdPolo;
                          const initialValues = poleInitialValues[idPolo] || { qtdeUso: rowValue, idCupomRecorrencia: rowRecorrencia };
                          const currentValues = poleCurrentValues[idPolo] || { qtdeUso: rowValue, idCupomRecorrencia: rowRecorrencia };
                          const hasChanges = poleHasChanges[idPolo] || false;
                          const containerId = `polo-container-${idPolo}`;

                          const checkChanges = (qtdeUsoVal, idCupomRecorrenciaVal) => {
                            return initialValues.qtdeUso !== String(qtdeUsoVal) ||
                              initialValues.idCupomRecorrencia !== String(idCupomRecorrenciaVal);
                          };

                          return (
                            <div id={containerId} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                              <input
                                type="number"
                                className="input-sm"
                                value={currentValues.qtdeUso}
                                min="0"
                                disabled={isDisabled}
                                onKeyDown={(e) => {
                                  if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = e.target.value || '0';
                                  let finalValue = value;
                                  if (value && parseInt(value, 10) < 0) {
                                    finalValue = '0';
                                  }
                                  // Atualizar valor atual
                                  setPoleCurrentValues(prev => ({
                                    ...prev,
                                    [idPolo]: {
                                      ...currentValues,
                                      qtdeUso: finalValue
                                    }
                                  }));
                                  // Verificar se há mudanças
                                  setPoleHasChanges(prev => ({
                                    ...prev,
                                    [idPolo]: checkChanges(finalValue, currentValues.idCupomRecorrencia)
                                  }));
                                }}
                                style={{
                                  width: '80px',
                                  textAlign: 'center',
                                  opacity: isDisabled ? 0.6 : 1,
                                  cursor: isDisabled ? 'not-allowed' : 'text'
                                }}
                              />
                              <select
                                className="input-sm"
                                value={currentValues.idCupomRecorrencia}
                                disabled={isDisabled}
                                onChange={(e) => {
                                  const newRecorrencia = e.target.value;
                                  // Atualizar valor atual
                                  setPoleCurrentValues(prev => ({
                                    ...prev,
                                    [idPolo]: {
                                      ...currentValues,
                                      idCupomRecorrencia: newRecorrencia
                                    }
                                  }));
                                  // Verificar se há mudanças
                                  setPoleHasChanges(prev => ({
                                    ...prev,
                                    [idPolo]: checkChanges(currentValues.qtdeUso, newRecorrencia)
                                  }));
                                }}
                                style={{
                                  width: '160px',
                                  textAlign: 'center',
                                  opacity: isDisabled ? 0.6 : 1,
                                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                                }}
                              >
                                {idCupomRecorrenciaOptions.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <button
                                type="button"
                                className="btn btn-sm"
                                style={{
                                  width: '40px',
                                  minWidth: '40px',
                                  backgroundColor: hasChanges && !isDisabled ? '#007bff' : 'transparent',
                                  color: hasChanges && !isDisabled ? '#fff' : 'transparent',
                                  border: 'none',
                                  borderRadius: '5px',
                                  cursor: hasChanges && !isDisabled ? 'pointer' : 'default',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontWeight: 'bold',
                                  fontSize: '1.4rem',
                                  visibility: hasChanges && !isDisabled ? 'visible' : 'hidden',
                                  pointerEvents: hasChanges && !isDisabled ? 'auto' : 'none'
                                }}
                                disabled={!hasChanges || isDisabled}
                                onClick={(e) => {
                                  if (!hasChanges || isDisabled) return;
                                  const current = poleCurrentValues[idPolo] || { qtdeUso: rowValue, idCupomRecorrencia: rowRecorrencia };
                                  const qtdeUsoValue = parseInt(current.qtdeUso, 10) || 0;
                                  const idCupomRecorrenciaValue = parseInt(current.idCupomRecorrencia, 10) || 1;
                                  if (qtdeUsoValue >= 0) {
                                    dispatch(
                                      updateCouponPole({
                                        IdPolo: idPolo,
                                        IdCupom: row.IdCupom,
                                        Ativo: row.Ativo,
                                        QtdeUso: qtdeUsoValue,
                                        IdCupomRecorrencia: idCupomRecorrenciaValue
                                      })
                                    );
                                    // Atualizar valores iniciais e remover flag de mudança
                                    const newValues = {
                                      qtdeUso: String(qtdeUsoValue),
                                      idCupomRecorrencia: String(idCupomRecorrenciaValue)
                                    };
                                    setPoleInitialValues(prev => ({
                                      ...prev,
                                      [idPolo]: newValues
                                    }));
                                    setPoleCurrentValues(prev => ({
                                      ...prev,
                                      [idPolo]: newValues
                                    }));
                                    setPoleHasChanges(prev => ({
                                      ...prev,
                                      [idPolo]: false
                                    }));
                                  }
                                }}
                                title="Salvar alteração"
                              >
                                ✓
                              </button>
                            </div>
                          );
                        },
                      },
                      {
                        name: "Ativo",
                        selector: "Ativo",
                        width: '60px',
                        cell: (row) => (
                          <div
                            className="check-trail-module"
                            onClick={() => toogleCouponPole(row.IdPolo, row.IdCupom, !row.Ativo, row.QtdeUso, row.IdCupomRecorrencia)}
                          >
                            {row.Ativo ? (
                              <RiCheckboxFill size={25} color={colors.success} />
                            ) : (
                              <RiCheckboxBlankLine size={25} />
                            )}
                          </div>
                        ),
                      },
                    ]}
                    columnFilter="NomePolo"
                  />
                )}
              </S.CollapseBody>
            </S.CollapseItem>
          </>
        )
      )}
    </>
  );
}

export default CouponCreate;
